<template>
  <div
    v-loading="loading"
    class="card"
  >
    <el-container class="container">
      <el-header class="header">
        <div class="select-button">
          <el-radio-group
            v-model="target"
            class="card-select-button-group"
            @change="tarChange"
          >
            <el-radio
              v-model="target"
              label="1"
              border
            >
              基本资料
              <el-switch
                v-model="setting.value1"
                active-color="#009CFF"
                inactive-color="#D9D9D9"
                name="123123"
                disabled
              >
              </el-switch>
            </el-radio>
            <el-radio
              v-model="target"
              label="2"
              border
            >
              个人简介
              <el-switch
                v-model="setting.value2"
                active-color="#009CFF"
                inactive-color="#D9D9D9"
                name="123123"
                @change="switchChange(1, $event)"
              >
              </el-switch>
            </el-radio>
            <el-radio
              v-model="target"
              label="3"
              border
            >
              我的企业
              <el-switch
                v-model="setting.value3"
                active-color="#009CFF"
                inactive-color="#D9D9D9"
                name="123123"
                @change="switchChange(2, $event)"
              >
              </el-switch>
            </el-radio>
            <el-radio
              v-model="target"
              label="4"
              border
            >
              我的同事
              <el-switch
                v-model="setting.value4"
                active-color="#009CFF"
                inactive-color="#D9D9D9"
                name="123123"
                @change="switchChange(3, $event)"
              >
              </el-switch>
            </el-radio>
            <el-radio
              v-model="target"
              label="5"
              border
            >
              我的照片
              <el-switch
                v-model="setting.value5"
                active-color="#009CFF"
                inactive-color="#D9D9D9"
                name="123123"
                @change="switchChange(4, $event)"
              >
              </el-switch>
            </el-radio>
          </el-radio-group>
          <div>
          </div>
        </div>
      </el-header>
      <el-main class="main">
        <basic-form
          v-show="curPage === 'BasicForm'"
          :id="cardInfo.id"
          :form-data="cardInfo && cardInfo.profile"
        ></basic-form>
        <user-brief
          v-show="curPage === 'UserBrief'"
          :id="cardInfo.id"
          :form-data="cardInfo && cardInfo.introduction"
        ></user-brief>
        <my-com
          v-show="curPage === 'MyCom'"
          :id="cardInfo.id"
          :form-data="cardInfo && cardInfo.company"
        ></my-com>
        <my-colleague
          v-show="curPage === 'MyColleague'"
          :id="cardInfo.id"
          :form-data="cardInfo && cardInfo.workmate"
        ></my-colleague>
        <my-photos
          v-show="curPage === 'MyPhotos'"
          :id="cardInfo.id"
          :form-data="cardInfo && cardInfo.picture"
        ></my-photos>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import BasicForm from './components/basic-form'
import UserBrief from './components/user-brief'
import MyCom from './components/my-com'
import MyColleague from './components/my-colleague'
import MyPhotos from './components/my-photos'
export default {
  name: 'Card',
  components: { BasicForm, UserBrief, MyCom, MyColleague, MyPhotos },
  data () {
    return {
      // 当前页面
      target: '1',
      // 顶部按钮数据
      setting: {
        value1: true,
        value2: true,
        value3: true,
        value4: false,
        value5: true
      },
      // 卡片信息
      cardInfo: {
        profile: null,
        introduction: null,
        company: null,
        workmate: null,
        picture: null
      },
      // 当前显示组件
      curPage: 'BasicForm',
      loading: false
    }
  },
  mounted () {
    this.getCardInfo()
  },
  methods: {
    // 获取卡信息
    async getCardInfo () {
      this.loading = true
      let res = await JINGTUIAPIS.CardApi.cardGet({ id: '' })
      this.loading = false
      this.cardInfo = res.data
      this.setting.value2 = this.cardInfo.introduction.isActive
      this.setting.value3 = this.cardInfo.company.isActive
      this.setting.value4 = this.cardInfo.workmate.isActive
      this.setting.value5 = this.cardInfo.picture.isActive
    },
    // 上方switch切换
    tarChange (val) {
      switch (val) {
        case '1':
          this.curPage = 'BasicForm'
          break
        case '2':
          this.curPage = 'UserBrief'
          break
        case '3':
          this.curPage = 'MyCom'
          break
        case '4':
          this.curPage = 'MyColleague'
          break
        case '5':
          this.curPage = 'MyPhotos'
          break
        default:
          this.curPage = 'BasicForm'
          break
      }
    },
    // radio开关
    switchChange (type, val) {
      let data, key
      switch (type) {
        case 1:
          this.cardInfo.introduction.isActive = val
          key = 'introduction'
          break
        case 2:
          this.cardInfo.company.isActive = val
          key = 'company'
          break
        case 3:
          this.cardInfo.workmate.isActive = val
          key = 'workmate'
          break
        case 4:
          this.cardInfo.picture.isActive = val
          key = 'picture'
          break
        default:
          break
      }
      this.updateInfo(key)
    },
    // 更新信息
    async updateInfo (key, data) {
      let params = {}
      params[key] = this.cardInfo[key]
      this.loading = true
      let res = await JINGTUIAPIS.CardApi.cardPut(
        {
          id: this.cardInfo.id
        },
        params
      )
      this.loading = false
      if (res.success) {
        if (this.cardInfo[key].isActive) {
          this.$message.success('模块已开启，在小程序中可见')
        } else {
          this.$message.warning('模块已关闭，在小程序中隐藏')
        }
        this.form = res.data[0].introduction
      } else {
        this.$message.success('保存失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  background-color: #fff;
  height: 100%;

  .container {
    height: 100%;
    overflow: hidden;

    .header {
      margin: 20px 0 20px;
      height: auto !important;
    }

    .main {
      overflow: hidden;
      padding: 0;
      display: flex;
      width: 100%;
      height: 100%;
    }
  }

  .select-button {
    .card-select-button-group {
      max-width: 1000px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
  }

  // 子页面公用的样式
  /deep/ .form-title {
    color: #000;
    font-size: 14px;
    position: relative;
    text-indent: 18px;

    &::before {
      content: '';
      display: inline-block;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      width: 4px;
      height: 16px;
      background: #009cff;
      border-radius: 1px;
      margin-right: 8px;
    }
  }

  /deep/ .common-container {
    position: relative;
    height: 100%;

    .main {
      margin-bottom: 56px;
      padding: 0 20px 0;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .button-footer {
      position: absolute;
      width: 100%;
      height: 56px;
      bottom: 0;
      text-align: center;
    }
  }

  // 清除elemnt样式
  /deep/ .el-radio {
    margin: 0;
  }

  /deep/ .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0;
  }
}
</style>
